<cb-dialog dialogHeading="View Manual Purchase Order">
    <form name="manualPurchaseOrderForm">
        <div class="cb-margin flex-row">
            <div class="flex-col flex">
                <span class="cb-title">Order To - {{ mappedItem.supplierName }}</span>
                <cb-display-value-new label="Postal Address">
                    <span class="mat-body-2">
                        {{ mappedItem.supplierStreetAddress | cbDasher }}
                        <br />
                        {{ mappedItem.supplierSuburb | cbDasher }}
                        <br />
                        {{ mappedItem.supplierPostCode | cbDasher }}
                        <br />
                        {{ mappedItem.supplierCity | cbDasher }}
                        <br />
                        {{ mappedItem.supplierAddressRegion | cbDasher }}
                        <br />
                    </span>
                </cb-display-value-new>
                <cb-display-value-new
                    label="Email Address"
                    [value]="mappedItem.supplierEmailAddress"
                >
                </cb-display-value-new>
                <cb-display-value-new label="Cost Nature">
                    {{ COST_NATURE_ENUM[mappedItem.costNature] }}
                </cb-display-value-new>
                @if (isExtraToClient) {
                    <cb-display-value-new label="Client Variation">
                        @if (mappedItem.variationId) {
                            <div>
                                <span class="mat-body-strong">
                                    {{ 'VO#' + mappedItem.variationNumber }}
                                </span>
                                -
                                <span>
                                    {{ mappedItem.variationAmount | cbCurrency: 'addGst' }} (Inc
                                    Gst)
                                </span>
                            </div>
                        }
                        @if (!mappedItem.variationId) {
                            <div class="start-center flex-row">
                                <mat-icon class="mat-warn">warning</mat-icon>
                                A Variation Needs to be Selected
                            </div>
                        }
                    </cb-display-value-new>
                }
                @if (isOrderExtraToSupplier) {
                    <div class="flex-col flex">
                        <cb-display-value-new
                            label="Chargable Business Account"
                            [value]="mappedItem.chargeableBusinessAccountName"
                        >
                        </cb-display-value-new>
                        <cb-display-value-new
                            label="Chargable Business Account Contact"
                            [value]="
                                mappedItem.chargeableBusinessAccountContactName ||
                                mappedItem.freeTextChargeableBusinessAccountContact
                            "
                        >
                        </cb-display-value-new>
                        <cb-display-value-new
                            label="Discussion Comments"
                            [value]="mappedItem.discussionDescription"
                        >
                        </cb-display-value-new>
                        @if (mappedItem.discussionDate) {
                            <cb-display-value-new label="Discussion Date">
                                {{ mappedItem.discussionDate | date }}
                            </cb-display-value-new>
                        }
                    </div>
                }
                <cb-display-value-new
                    label="Comments"
                    [value]="mappedItem.comments"
                ></cb-display-value-new>
            </div>
            <div class="flex-col flex">
                <span class="cb-title">Order #{{ mappedItem.orderNumber }}</span>
                <cb-display-value-new label="Order Date">
                    <span>{{ mappedItem.orderDate | date }}</span>
                </cb-display-value-new>
                <cb-display-value-new label="Activity">
                    <span>{{ mappedItem.activityCode }} - {{ mappedItem.activityName }}</span>
                </cb-display-value-new>
                @if (mappedItem.buildProgrammeActivity && mappedItem.buildProgrammeActivityId) {
                    <cb-display-value-new label="Start Date">
                        {{ mappedItem.buildProgrammeActivity.startDate | date }}
                    </cb-display-value-new>
                }
                @if (mappedItem.buildProgrammeActivity && mappedItem.buildProgrammeActivityId) {
                    <cb-display-value-new label="End Date">
                        {{ mappedItem.buildProgrammeActivity.endDate | date }}
                    </cb-display-value-new>
                }
                @if (mappedItem.buildProgrammeActivity && mappedItem.buildProgrammeActivityId) {
                    <cb-display-value-new label="Duration Days">
                        {{ mappedItem.buildProgrammeActivity.duration }}
                    </cb-display-value-new>
                }
                <cb-display-value-new
                    label="Order Status"
                    [value]="PURCHASE_ORDER_STATUS_ENUM[mappedItem.statusId]"
                >
                </cb-display-value-new>
                <span class="mat-body-strong">Approval</span>
                <cb-display-value-new class="flex-col" label="Approval Status">
                    @if (showPendingSince.value) {
                        <span class="mat-body-2 cb-margin-botom"
                            >Pending since {{ mappedItem.submittedDate | date }}</span
                        >
                    }
                    @if (
                        !showPendingSince.value &&
                        mappedItem.approvedByName != undefined &&
                        mappedItem.approvedDate != undefined
                    ) {
                        <cb-user-date-time-new
                            [label]="mappedItem.approvalStatusLabel + ' by'"
                            [date]="mappedItem.approvedDate"
                            [userFullName]="mappedItem.approvedByName"
                        >
                        </cb-user-date-time-new>
                    }
                </cb-display-value-new>
                <cb-display-value-new
                    label="Approval Comments"
                    [value]="mappedItem.approvalComments"
                ></cb-display-value-new>
            </div>
        </div>
        <div class="cb-margin flex-row">
            <div class="flex-col flex">
                <div class="standardTable mat-body-2">
                    <table>
                        <thead>
                            <tr>
                                <td>Code</td>
                                <td>Item</td>
                                <td class="right-align">UOM</td>
                                <td class="right-align">Quantity</td>
                                <td class="right-align">Rate</td>
                                <td class="right-align">Subtotal</td>
                                <td class="right-align">GST</td>
                                <td class="actions"></td>
                            </tr>
                        </thead>
                        <tbody>
                            @for (
                                lineItem of mappedItem.mappedLines
                                    | cbSortByPipe: 'createdDate' : 'asc'
                                    | cbSortByPipe: 'sortOrder' : 'asc';
                                track lineItem
                            ) {
                                <tr [ngClass]="{ poLineUnknownRate: lineItem.costToBeDetermined }">
                                    @if (lineItem.isNoteLine) {
                                        <td colspan="7">
                                            <span
                                                class="restricted-width-text"
                                                cb-percentage-max-width="70"
                                                >{{ lineItem.description | cbDasher }}</span
                                            >
                                        </td>
                                    }
                                    @if (!lineItem.isNoteLine) {
                                        <td>{{ lineItem.productCode | cbDasher }}</td>
                                        <td>{{ lineItem.description | cbDasher }}</td>
                                        <td class="right-align">{{ lineItem.uom }}</td>
                                        <td class="right-align">{{ lineItem.quantity }}</td>
                                        <td class="right-align">
                                            {{ lineItem.rate | cbCurrency }}
                                        </td>
                                        <td class="right-align">
                                            {{ lineItem.lineSubtotalCalc() | cbCurrency }}
                                        </td>
                                        <td class="actions">
                                            <mat-icon
                                                >{{
                                                    lineItem.gstApplies
                                                        ? 'check_box'
                                                        : 'check_box_outline_blank'
                                                }}
                                            </mat-icon>
                                        </td>
                                    }
                                    <td class="actions layoutGap-8">
                                        @if (canManage.value) {
                                            <button
                                                mat-icon-button
                                                (click)="editLineItem(lineItem)"
                                            >
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                        }
                                        @if (canManage.value) {
                                            <button
                                                mat-icon-button
                                                (click)="removeLineItem(lineItem)"
                                            >
                                                <mat-icon>remove_circle</mat-icon>
                                            </button>
                                        }
                                    </td>
                                </tr>
                                @if (lineItem.notes) {
                                    <tr
                                        [ngClass]="{
                                            poLineUnknownRate: lineItem.costToBeDetermined
                                        }"
                                    >
                                        <td style="width: 30px">
                                            <mat-icon class="cb-small-icon"
                                                >insert_drive_file</mat-icon
                                            >
                                        </td>
                                        <td></td>
                                        <td>
                                            <span class="mat-body-2 preserve-line-breaks">{{
                                                lineItem.notes
                                            }}</span>
                                        </td>
                                        <td colspan="5"></td>
                                    </tr>
                                }
                            }
                            @if (canManage.value) {
                                <tr>
                                    <td colspan="7">
                                        @if (mappedItem.mappedLines.length < 1) {
                                            <span>
                                                <cb-info-message
                                                    message="There are no Line Items on this Manual Order"
                                                    icon="info_circle"
                                                    iconClass="mat-accent"
                                                >
                                                </cb-info-message>
                                            </span>
                                        }
                                    </td>
                                    <td class="actions">
                                        <button mat-icon-button [matMenuTriggerFor]="addLineMenu">
                                            <mat-icon>add</mat-icon>
                                        </button>
                                        <mat-menu #addLineMenu="matMenu">
                                            <button mat-menu-item (click)="addLineItem()">
                                                <mat-icon>assignment</mat-icon>
                                                Line Item
                                            </button>
                                            <button mat-menu-item (click)="addNoteLine()">
                                                <mat-icon>note_add</mat-icon>
                                                Note Line
                                            </button>
                                        </mat-menu>
                                    </td>
                                </tr>
                            }
                            <tr>
                                <td colspan="6" class="right-align">
                                    <div class="right-align end-center flex-row">
                                        <div class="flex-col">
                                            <span class="mat-body-2">
                                                Subtotal:
                                                {{ mappedItem.orderSubtotalCalc() | cbCurrency }}
                                            </span>
                                            <span class="mat-body-2">
                                                GST: {{ mappedItem.orderGstCalc() | cbCurrency }}
                                            </span>
                                            <span class="mat-body-strong">
                                                Total:
                                                {{ mappedItem.orderTotalCalc() | cbCurrency }}
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td colspan="2" class="actions"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </form>
    <div actions class="flex flex-row center-right">
        @if (!data.downloadOnly && isExtraToClient) {
            <button mat-raised-button color="primary" (click)="selectVariation()">
                <mat-icon>search</mat-icon>
                &nbsp;Select Client Variation
            </button>
        }
        @if (mappedItem.canDownload) {
            <button mat-raised-button color="primary" (click)="mappedItem.download()">
                <mat-icon>file_download</mat-icon>
                &nbsp;Download
            </button>
        }
        @if (canManage.value) {
            <button mat-raised-button color="accent" (click)="edit()">Edit Order Details</button>
        }
        @if (canSubmit.value) {
            <span
                class="inline-tooltip-wrapper cb-margin-left cb-margin-right"
                [matTooltip]="getCostActionDisabledText()"
                [matTooltipDisabled]="!isCostActionDisabled"
                matTooltipPosition="above"
            >
              <button
                  mat-raised-button
                  color="accent"
                  (click)="submit()"
                  [disabled]="isCostActionDisabled"
              >
                Submit Manual Order
              </button>
            </span>
        }
        @if (canUnsubmit.value) {
            <button mat-raised-button color="primary" (click)="unsubmit()">
                Withdraw Submission
            </button>
        }
        @if (canReview.value) {
            <button mat-raised-button color="primary" (click)="review()">Review</button>
        }
        @if (canManage.value || canSubmit.value || canUnsubmit.value || canReview.value) {
            <div class="flex-row">
                <mat-divider style="height: 36px; margin: 0 12px 0 18px"></mat-divider>
            </div>
        }
        <button mat-raised-button (click)="cancel()">Close</button>
    </div>
</cb-dialog>
